import _ from 'lodash';

import { accommodations } from '../../api/api'

export const FETCH_ACCOMMODATIONS_BEGIN   = 'FETCH_ACCOMMODATIONS_BEGIN'
export const FETCH_ACCOMMODATIONS_SUCCESS = 'FETCH_ACCOMMODATIONS_SUCCESS'
export const FETCH_ACCOMMODATIONS_ERROR = 'FETCH_ACCOMMODATIONS_ERROR'

export const fetchAccommodations = () => (dispatch, getState) => {
  dispatch({ type: FETCH_ACCOMMODATIONS_BEGIN })
  const brand = _.get(getState(), 'configurationData.data.brand')
  return accommodations(brand)
    .then(response => dispatch({ type: FETCH_ACCOMMODATIONS_SUCCESS, payload: response }))
    .catch(error => dispatch({ type: FETCH_ACCOMMODATIONS_ERROR, payload: true }))
}
